import { render, staticRenderFns } from "./unused-comp_ProductsCarousel.vue?vue&type=template&id=161a1f92&"
import script from "./unused-comp_ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./unused-comp_ProductsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports